"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredIntermediateFieldIterable = void 0;
// ************   INTERMEDIATE FIELDS   ************
exports.RequiredIntermediateFieldIterable = [
    'reportingDate', // Provided by borrowing base report
    'collectionsCash', // Provided by borrowing base report
    'borrowingBaseReserve', // Expected output for borrowing base reserve
    'collectionsReserve', // Expected output for cash reserve (collections)
];
//# sourceMappingURL=Inputs.js.map